import { get, put, post, authAxios } from '../../lib/api';
import endpoints from '../../lib/endpoints';
import { Profile, PreferenceDefinition } from '../../models/user';

const COOKIE_NAME = process.env.COOKIE_NAME;

export const getPreferenceDefinitions = (): Promise<PreferenceDefinition[]> =>
  get(endpoints.userPreferenceDefinitions);
export const getProfile = (token?: string): Promise<Profile> =>
  get(
    endpoints.userProfile,
    token && {
      headers: {
        Cookie: `${COOKIE_NAME}=${token}`,
      },
    }
  );

export const saveProfile = (profile: Profile): Promise<Profile> =>
  put(endpoints.userProfile, profile);

export const saveAvatar = async (avatar: File): Promise<any> => {
  const data = new FormData();

  data.append('file', avatar);

  return post(endpoints.avatar, data);
};

export const getMemberProfile = (email: string): Promise<object> =>
  get(`${endpoints.memberProfile}?email=${email}`);

export const saveMemberProfile = (profile: any): Promise<any> =>
  post(`${endpoints.memberProfile}`, { ...profile });
